import React from 'react';
import PropTypes from 'prop-types';
import { PreviewWrapper, CopyWrapper, InfoDivider, LogInButton } from '../../fieldvision.style';
import Image from '@mlb/react-patterns/v4/components/Image/image';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import { withTheme } from 'styled-components';
import { TYPES } from './index';

const Preview = ({
    setAccountType
}) => {
    const translate = useTranslate();

    const onLoginClick = () => {
        setAccountType(TYPES.LOGIN);
    };
    const translaedLogin = translate('fieldvision_preview_login', 'Log In');
    return (
        <PreviewWrapper>
            <header>{ translate('fieldvision_preview_title', 'Gameday 3D') }</header>
            <Image
                src={ 'https://storage.googleapis.com/mlb-bdata-prod-us-east4-field-vision-builds/build/images/fieldvision-intro-lq.gif' }
                alt={ 'field vision preview'}
                width={'100%'}
            />
            <CopyWrapper>
                { translate('fieldvision_preview_body', 'Login or create a FREE MLB account to get started') }
            </CopyWrapper>
            <InfoDivider />
            <LogInButton
                ariaLabel={translaedLogin}
                label={translaedLogin}
                hasHover={true}
                width={'208px'}
                height={'48px'}
                handlers={{onClick: onLoginClick}}
            />
        </PreviewWrapper>
    );
};

Preview.propTypes = {
    setAccountType: PropTypes.func
};

export default withTheme(Preview);
